export default __webpack_public_path__ + "static/media/Coloring-blue.df3a4d16.svg";